import { useCallback } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useNavigate, useRouter } from "@tanstack/react-router";
import { completeSignOut } from "@/lib/auth";

export function useCompleteSignOut() {
  const queryClient = useQueryClient();
  const router = useRouter();
  const navigate = useNavigate();

  return useCallback(
    () =>
      completeSignOut({
        queryClient,
        invalidateRouter: () => router.invalidate(),
        navigateToLogin: () =>
          navigate({ to: "/login", search: {}, replace: true }),
      }),
    [queryClient, router, navigate],
  );
}
